import { render, staticRenderFns } from "./ChampionshipEventList.vue?vue&type=template&id=997bde96&"
import script from "./ChampionshipEventList.vue?vue&type=script&lang=js&"
export * from "./ChampionshipEventList.vue?vue&type=script&lang=js&"
import style0 from "./ChampionshipEventList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports